module.exports = __webpack_public_path__ + "9779d9a1/img/comment-question-icon.7dd26e04.svg";